/**
 * F-impersonate-tab (CEO 2026-09-17: "ao clicar deve abrir outra aba") — a
 * sessão "Entrar como" vive POR ABA: o token vai no fragmento da URL da aba
 * nova (#imp=…, nunca enviado ao servidor), é movido para sessionStorage
 * (isolado por aba) e viaja como header Authorization. O cookie do admin
 * fica intocado — as outras abas continuam como admin.
 */

const KEY = "eurostorm:impersonationToken";

/** Lê o #imp= da URL (aba recém-aberta), guarda por aba e limpa o hash. */
export function bootstrapImpersonationFromHash(): void {
  try {
    const m = window.location.hash.match(/^#imp=(.+)$/);
    if (!m?.[1]) return;
    sessionStorage.setItem(KEY, decodeURIComponent(m[1]));
    history.replaceState(null, "", window.location.pathname + window.location.search);
  } catch {
    /* sessionStorage indisponível — segue sem impersonação */
  }
}

export function getImpersonationToken(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearImpersonationToken(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
